import React, { useEffect, useState } from 'react';
import { Alert, Button, Tooltip } from 'antd';
import { FolderOpenOutlined, ReloadOutlined } from '@ant-design/icons';
import { getWaveformDirectories } from '../services/api';

export default function WaveformSubfolders({ directory, refreshedAt, ready, onSelect }) {
  const [retry, setRetry] = useState(0);
  const [result, setResult] = useState({ directory: '', folders: [], loading: false, error: '' });
  useEffect(() => {
    let stopped = false;
    setResult({ directory, folders: [], loading: Boolean(ready && directory), error: '' });
    if (ready && directory) {
      getWaveformDirectories(directory).then(response => {
        if (stopped) return;
        if (!response.data.success) throw new Error(response.data.message || '获取子文件夹失败');
        setResult({ directory, folders: response.data.data, loading: false, error: '' });
      }).catch(error => {
        if (!stopped) setResult({ directory, folders: [], loading: false,
          error: error.response?.data?.message || error.message || '获取子文件夹失败' });
      });
    }
    return () => { stopped = true; };
  }, [directory, refreshedAt, ready, retry]);

  if (!directory || result.directory !== directory || (!result.loading && !result.error && !result.folders.length)) return null;
  return (
    <section className="waveform-subfolders" aria-label="子文件夹">
      <div className="waveform-subfolder-heading">
        {result.loading ? '正在读取子文件夹' : `子文件夹（${result.folders.length}）`}
      </div>
      {result.error && <Alert type="error" showIcon title={result.error}
        action={<Button size="small" icon={<ReloadOutlined />} onClick={() => setRetry(value => value + 1)}>重试</Button>} />}
      <div className="waveform-subfolder-list">
        {result.folders.map(folder => (
          <Tooltip key={folder.id} title={folder.relative_path}>
            <Button type="text" icon={<FolderOpenOutlined />} aria-label={`打开子文件夹 ${folder.name}`}
              onClick={() => onSelect(folder.relative_path)}>{folder.name}</Button>
          </Tooltip>
        ))}
      </div>
    </section>
  );
}
